import styles from './EmbedResult.module.css';

interface EmbedResultProps {
  embed: string;
}

function EmbedResult(props: EmbedResultProps) {

  const { embed } = props;

  const result = embed !== '' ? (
    <div className="border-2 m-5 p-4 rounded-md">
      <code className="break-all">
        { embed }
      </code>
    </div>
  ) : null;

  return result;
}

export default EmbedResult;